import { useEffect, useState } from 'react';
import { Button, Icon, Row, Col, FormGroup, Label, CustomInput } from '@polichat/flamboyant';


import CreateBodyWaba from './body/CreateBodyWaba.component';
import CreateButtonWaba from './button/CreateButtonWaba.component';
import CreateFooterWaba from './footer/CreateFooterWaba.component';
import CreateHeaderWaba from './header/CreateHeaderWaba.component';
import SelectCategoryWaba from './categories/SelectCategoryWaba.component';
import SelectLanguageWaba from './language/SelectLanguageWaba.component';

import { LabelWithSpan } from '../FormMessagesBuilder.styles';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';

function FormTemplateWaba({ onUpdate , initialValue, isEdit}) {
  const buttonType = useGlotaT('spa.messageBuilder.button.type');
  const buttonLimit = useGlotaT('spa.messageBuilder.button.limit');
  const buttonReply = useGlotaT('spa.messageBuilder.button.reply');
  const buttonAction = useGlotaT('spa.messageBuilder.button.action');
  const buttonCopy = useGlotaT('spa.messageBuilder.button.copy');
  const buttonAdd = useGlotaT('spa.messageBuilder.button.add');
  const { header, body, buttons, footer, options } = initialValue;

  const [messageButtons, setMessageButtons] = useState(buttons);
  const [messageHeader, setMessageHeader] = useState(header);
  const [messageBody, setMessageBody] = useState(body);
  const [messageFooter, setMessageFooter] = useState(footer);
  const [messageOptions, setMessageOptions] = useState(options);

  const buttonsType = [
    { id: 1, type: 'reply', description: buttonReply, limit: 10 },
    { id: 2, type: 'action', description: buttonAction, limit: 2 },
    { id: 3, type: 'url', description: buttonCopy, limit: 1 }
  ]
  const [buttonWabaType, setButtonWabaType] = useState(() => {
    const initialState =  messageButtons.length ? buttonsType.filter(btn => btn.type === messageButtons[0].type)[0] : buttonsType[0]
    return initialState
  });

  const [isDisabledAddButton, setIsDisabledAddButton] = useState(() => {
    if (messageButtons.length === 0) return false;
    const currentButtonType = buttonsType.filter(btn => btn.type === messageButtons[0].type)[0];
    return messageButtons.length >= currentButtonType.limit;
  });

    const updateHeaderData = (headerData) => {
      setMessageHeader(headerData);
    }

    const updateOptionsData = (optionsData) => {
      setMessageOptions({...messageOptions, ...optionsData});
    }

    const updateBodyData = (bodyData) => {
      setMessageBody(bodyData);
    }

    const updateFooterData = (footerData) => {
      setMessageFooter(footerData);
    }

    const handleAddButton = () => {
      if(isDisabledAddButton) return
    setMessageButtons([...messageButtons,{
          id: new Date().getTime(),
          type: buttonWabaType.type,
          text: "",
        actionType: buttonWabaType.type === 'url' ? '' : "call",
        actionText: ""
        }
      ]);

      messageButtons.length + 1 >= buttonWabaType.limit && setIsDisabledAddButton(true)

    }

    const handleRemoveButton = (id) => {
      if(messageButtons.length <= 0 ) return
      setMessageButtons(messageButtons.filter(button => button.id != id))
      setIsDisabledAddButton(false);
    }

    const handleChangeButtonType = ({target: {name, value}}) => {
      const newButtonType = buttonsType.filter(btn => btn.type === value)[0];
      setButtonWabaType(newButtonType);
      setMessageButtons([{
          id: new Date().getTime(),
          type: value,
          text: "",
        actionType: value === 'reply' || value === 'url' ? '' :  "call",
        actionText: ''
        }
      ]);

      setIsDisabledAddButton(newButtonType.limit === 1);
    }

    const updateButtonData = (buttonData) => {
      const { id } = buttonData;
      let filteredButtons = messageButtons.filter(btn => btn.id !== id);
      filteredButtons.push(buttonData)
      filteredButtons = filteredButtons.sort((a, b) => {
        if (a.id < b.id) return -1;
        if (a.id > b.id) return 1;
        return 0;
      });
      setMessageButtons(filteredButtons);

    }

  useEffect(() => {
    onUpdate({
      header: messageHeader,
      body:  messageBody,
      footer:  messageFooter,
      buttons: messageButtons,
      options: messageOptions
    })
  }, [messageOptions, messageHeader, messageBody, messageFooter, messageButtons]);

  return (
   <>
    <Row>
      <SelectCategoryWaba onUpdate={updateOptionsData} initialValue={messageOptions.category} isEdit={isEdit}/>
      <SelectLanguageWaba onUpdate={updateOptionsData} initialValue={messageOptions.language} isEdit={isEdit}/>
    </Row>
    <CreateHeaderWaba onUpdate={updateHeaderData} initialValue={messageHeader} isEdit={isEdit}/>
    <CreateBodyWaba onUpdate={updateBodyData}  initialValue={messageBody} isEdit={isEdit}/>
    <CreateFooterWaba onUpdate={updateFooterData} initialValue={messageFooter} isEdit={isEdit}/>
    <Row>
      {messageButtons.length >= 1 &&
        <Col sm={12} md={6}>
          <FormGroup>
            <LabelWithSpan>
              <Label>{buttonType}</Label>
              <span>{buttonLimit.replace('{limit}', buttonWabaType.limit)}</span>
            </LabelWithSpan>
            <CustomInput
              type="select"
              id="button-waba"
              name="type"
              value={buttonWabaType.type}
              onChange={handleChangeButtonType}
              disabled={isEdit}
              >
              {buttonsType.map(btType => (
                <option
                key={btType.id}
                value={btType.type}
                >
                  {btType.description}
                </option>))}
            </CustomInput>
          </FormGroup>
        </Col>
      }
    </Row>
    {messageButtons.map(button => (
      <Row key={button.id}>
        <CreateButtonWaba
          id={button.id}
          removeButton={handleRemoveButton}
          onUpdate={updateButtonData}
          initialValue={button}
          isEdit={isEdit}
          />
      </Row>
      ))}
      <Button color="secondary-link"
        onClick={handleAddButton}
        disabled={isEdit || isDisabledAddButton}>
        <Icon
        icon="poli-icon pi-add-circle-line"
        size={20}
        position={"relative"}
        top={"2px"}
        right={"2px"}/>
        <span>{buttonAdd}</span>
      </Button>
  </>)
};

export default FormTemplateWaba;
